import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../shared/button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonSize, ButtonState, ButtonType, INote } from '../../../assets/types/dtoTypes';

@Component({
  selector: 'app-add-note-modal',
  standalone: true,
  imports: [ReactiveFormsModule, ButtonComponent, TranslateModule],
  templateUrl: './add-note-modal.component.html',
  styleUrl: './add-note-modal.component.scss'
})
export class AddNoteModalComponent implements OnInit {
  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonState = ButtonState;
  protected readonly ButtonType = ButtonType;

  noteForm!: FormGroup;
  isEdit = false;

  constructor(
    private dialogRef: MatDialogRef<AddNoteModalComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: Partial<INote> | null
  ) {}

  ngOnInit(): void {
    this.isEdit = !!this.data;
    this.noteForm = this.fb.group({
      title: [this.data?.title ?? '', Validators.required],
      content: [this.data?.content ?? '', Validators.required],
    });
  }

  submitNote() {
    if (this.noteForm.invalid) return;

    const payload: Partial<INote> = {
      id: this.data?.id,
      applicationId: this.data?.applicationId,
      type: this.data?.type ?? 'GENERAL',
      ...this.noteForm.value
    };

    this.dialogRef.close(payload);
  }
}
